/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SelectPanelRouteImport } from './routes/select-panel'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedUsersRouteImport } from './routes/_authed.users'
import { Route as AuthedSupportRouteImport } from './routes/_authed.support'
import { Route as AuthedSshDevicesRouteImport } from './routes/_authed.ssh-devices'
import { Route as AuthedSitesRouteImport } from './routes/_authed.sites'
import { Route as AuthedRemediationRouteImport } from './routes/_authed.remediation'
import { Route as AuthedPushCampaignsRouteImport } from './routes/_authed.push-campaigns'
import { Route as AuthedPartnersRouteImport } from './routes/_authed.partners'
import { Route as AuthedOrganizationsRouteImport } from './routes/_authed.organizations'
import { Route as AuthedNotificationsRouteImport } from './routes/_authed.notifications'
import { Route as AuthedDevicesRouteImport } from './routes/_authed.devices'
import { Route as AuthedDealersRouteImport } from './routes/_authed.dealers'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedCniRouteImport } from './routes/_authed.cni'
import { Route as AuthedAlarmsRouteImport } from './routes/_authed.alarms'
import { Route as AuthedCniUsersRouteImport } from './routes/_authed.cni.users'
import { Route as AuthedCniTenantsRouteImport } from './routes/_authed.cni.tenants'
import { Route as AuthedCniTariffsRouteImport } from './routes/_authed.cni.tariffs'
import { Route as AuthedCniSshDevicesRouteImport } from './routes/_authed.cni.ssh-devices'
import { Route as AuthedCniScadaRouteImport } from './routes/_authed.cni.scada'
import { Route as AuthedCniRolesRouteImport } from './routes/_authed.cni.roles'
import { Route as AuthedCniPermissionsRouteImport } from './routes/_authed.cni.permissions'
import { Route as AuthedCniPackagesRouteImport } from './routes/_authed.cni.packages'
import { Route as AuthedCniLicensesRouteImport } from './routes/_authed.cni.licenses'
import { Route as AuthedCniFirmsRouteImport } from './routes/_authed.cni.firms'
import { Route as AuthedCniFeaturesRouteImport } from './routes/_authed.cni.features'
import { Route as AuthedCniFacilitiesRouteImport } from './routes/_authed.cni.facilities'
import { Route as AuthedCniDevicesRouteImport } from './routes/_authed.cni.devices'
import { Route as AuthedCniDashboardRouteImport } from './routes/_authed.cni.dashboard'
import { Route as AuthedCniAuditRouteImport } from './routes/_authed.cni.audit'
import { Route as AuthedCniLicensesIndexRouteImport } from './routes/_authed.cni.licenses.index'
import { Route as AuthedCniFirmsIndexRouteImport } from './routes/_authed.cni.firms.index'
import { Route as AuthedCniLicensesIdRouteImport } from './routes/_authed.cni.licenses.$id'
import { Route as AuthedCniFirmsIdRouteImport } from './routes/_authed.cni.firms.$id'

const SelectPanelRoute = SelectPanelRouteImport.update({
  id: '/select-panel',
  path: '/select-panel',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportRoute = AuthedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSshDevicesRoute = AuthedSshDevicesRouteImport.update({
  id: '/ssh-devices',
  path: '/ssh-devices',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSitesRoute = AuthedSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRemediationRoute = AuthedRemediationRouteImport.update({
  id: '/remediation',
  path: '/remediation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPushCampaignsRoute = AuthedPushCampaignsRouteImport.update({
  id: '/push-campaigns',
  path: '/push-campaigns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPartnersRoute = AuthedPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrganizationsRoute = AuthedOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNotificationsRoute = AuthedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDevicesRoute = AuthedDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDealersRoute = AuthedDealersRouteImport.update({
  id: '/dealers',
  path: '/dealers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCniRoute = AuthedCniRouteImport.update({
  id: '/cni',
  path: '/cni',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAlarmsRoute = AuthedAlarmsRouteImport.update({
  id: '/alarms',
  path: '/alarms',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCniUsersRoute = AuthedCniUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniTenantsRoute = AuthedCniTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniTariffsRoute = AuthedCniTariffsRouteImport.update({
  id: '/tariffs',
  path: '/tariffs',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniSshDevicesRoute = AuthedCniSshDevicesRouteImport.update({
  id: '/ssh-devices',
  path: '/ssh-devices',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniScadaRoute = AuthedCniScadaRouteImport.update({
  id: '/scada',
  path: '/scada',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniRolesRoute = AuthedCniRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniPermissionsRoute = AuthedCniPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniPackagesRoute = AuthedCniPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniLicensesRoute = AuthedCniLicensesRouteImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniFirmsRoute = AuthedCniFirmsRouteImport.update({
  id: '/firms',
  path: '/firms',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniFeaturesRoute = AuthedCniFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniFacilitiesRoute = AuthedCniFacilitiesRouteImport.update({
  id: '/facilities',
  path: '/facilities',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniDevicesRoute = AuthedCniDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniDashboardRoute = AuthedCniDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniAuditRoute = AuthedCniAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedCniRoute,
} as any)
const AuthedCniLicensesIndexRoute = AuthedCniLicensesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedCniLicensesRoute,
} as any)
const AuthedCniFirmsIndexRoute = AuthedCniFirmsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedCniFirmsRoute,
} as any)
const AuthedCniLicensesIdRoute = AuthedCniLicensesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedCniLicensesRoute,
} as any)
const AuthedCniFirmsIdRoute = AuthedCniFirmsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedCniFirmsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/select-panel': typeof SelectPanelRoute
  '/alarms': typeof AuthedAlarmsRoute
  '/cni': typeof AuthedCniRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/dealers': typeof AuthedDealersRoute
  '/devices': typeof AuthedDevicesRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/organizations': typeof AuthedOrganizationsRoute
  '/partners': typeof AuthedPartnersRoute
  '/push-campaigns': typeof AuthedPushCampaignsRoute
  '/remediation': typeof AuthedRemediationRoute
  '/sites': typeof AuthedSitesRoute
  '/ssh-devices': typeof AuthedSshDevicesRoute
  '/support': typeof AuthedSupportRoute
  '/users': typeof AuthedUsersRoute
  '/cni/audit': typeof AuthedCniAuditRoute
  '/cni/dashboard': typeof AuthedCniDashboardRoute
  '/cni/devices': typeof AuthedCniDevicesRoute
  '/cni/facilities': typeof AuthedCniFacilitiesRoute
  '/cni/features': typeof AuthedCniFeaturesRoute
  '/cni/firms': typeof AuthedCniFirmsRouteWithChildren
  '/cni/licenses': typeof AuthedCniLicensesRouteWithChildren
  '/cni/packages': typeof AuthedCniPackagesRoute
  '/cni/permissions': typeof AuthedCniPermissionsRoute
  '/cni/roles': typeof AuthedCniRolesRoute
  '/cni/scada': typeof AuthedCniScadaRoute
  '/cni/ssh-devices': typeof AuthedCniSshDevicesRoute
  '/cni/tariffs': typeof AuthedCniTariffsRoute
  '/cni/tenants': typeof AuthedCniTenantsRoute
  '/cni/users': typeof AuthedCniUsersRoute
  '/cni/firms/$id': typeof AuthedCniFirmsIdRoute
  '/cni/licenses/$id': typeof AuthedCniLicensesIdRoute
  '/cni/firms/': typeof AuthedCniFirmsIndexRoute
  '/cni/licenses/': typeof AuthedCniLicensesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/select-panel': typeof SelectPanelRoute
  '/alarms': typeof AuthedAlarmsRoute
  '/cni': typeof AuthedCniRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/dealers': typeof AuthedDealersRoute
  '/devices': typeof AuthedDevicesRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/organizations': typeof AuthedOrganizationsRoute
  '/partners': typeof AuthedPartnersRoute
  '/push-campaigns': typeof AuthedPushCampaignsRoute
  '/remediation': typeof AuthedRemediationRoute
  '/sites': typeof AuthedSitesRoute
  '/ssh-devices': typeof AuthedSshDevicesRoute
  '/support': typeof AuthedSupportRoute
  '/users': typeof AuthedUsersRoute
  '/cni/audit': typeof AuthedCniAuditRoute
  '/cni/dashboard': typeof AuthedCniDashboardRoute
  '/cni/devices': typeof AuthedCniDevicesRoute
  '/cni/facilities': typeof AuthedCniFacilitiesRoute
  '/cni/features': typeof AuthedCniFeaturesRoute
  '/cni/packages': typeof AuthedCniPackagesRoute
  '/cni/permissions': typeof AuthedCniPermissionsRoute
  '/cni/roles': typeof AuthedCniRolesRoute
  '/cni/scada': typeof AuthedCniScadaRoute
  '/cni/ssh-devices': typeof AuthedCniSshDevicesRoute
  '/cni/tariffs': typeof AuthedCniTariffsRoute
  '/cni/tenants': typeof AuthedCniTenantsRoute
  '/cni/users': typeof AuthedCniUsersRoute
  '/cni/firms/$id': typeof AuthedCniFirmsIdRoute
  '/cni/licenses/$id': typeof AuthedCniLicensesIdRoute
  '/cni/firms': typeof AuthedCniFirmsIndexRoute
  '/cni/licenses': typeof AuthedCniLicensesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/select-panel': typeof SelectPanelRoute
  '/_authed/alarms': typeof AuthedAlarmsRoute
  '/_authed/cni': typeof AuthedCniRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/dealers': typeof AuthedDealersRoute
  '/_authed/devices': typeof AuthedDevicesRoute
  '/_authed/notifications': typeof AuthedNotificationsRoute
  '/_authed/organizations': typeof AuthedOrganizationsRoute
  '/_authed/partners': typeof AuthedPartnersRoute
  '/_authed/push-campaigns': typeof AuthedPushCampaignsRoute
  '/_authed/remediation': typeof AuthedRemediationRoute
  '/_authed/sites': typeof AuthedSitesRoute
  '/_authed/ssh-devices': typeof AuthedSshDevicesRoute
  '/_authed/support': typeof AuthedSupportRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/cni/audit': typeof AuthedCniAuditRoute
  '/_authed/cni/dashboard': typeof AuthedCniDashboardRoute
  '/_authed/cni/devices': typeof AuthedCniDevicesRoute
  '/_authed/cni/facilities': typeof AuthedCniFacilitiesRoute
  '/_authed/cni/features': typeof AuthedCniFeaturesRoute
  '/_authed/cni/firms': typeof AuthedCniFirmsRouteWithChildren
  '/_authed/cni/licenses': typeof AuthedCniLicensesRouteWithChildren
  '/_authed/cni/packages': typeof AuthedCniPackagesRoute
  '/_authed/cni/permissions': typeof AuthedCniPermissionsRoute
  '/_authed/cni/roles': typeof AuthedCniRolesRoute
  '/_authed/cni/scada': typeof AuthedCniScadaRoute
  '/_authed/cni/ssh-devices': typeof AuthedCniSshDevicesRoute
  '/_authed/cni/tariffs': typeof AuthedCniTariffsRoute
  '/_authed/cni/tenants': typeof AuthedCniTenantsRoute
  '/_authed/cni/users': typeof AuthedCniUsersRoute
  '/_authed/cni/firms/$id': typeof AuthedCniFirmsIdRoute
  '/_authed/cni/licenses/$id': typeof AuthedCniLicensesIdRoute
  '/_authed/cni/firms/': typeof AuthedCniFirmsIndexRoute
  '/_authed/cni/licenses/': typeof AuthedCniLicensesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/select-panel'
    | '/alarms'
    | '/cni'
    | '/dashboard'
    | '/dealers'
    | '/devices'
    | '/notifications'
    | '/organizations'
    | '/partners'
    | '/push-campaigns'
    | '/remediation'
    | '/sites'
    | '/ssh-devices'
    | '/support'
    | '/users'
    | '/cni/audit'
    | '/cni/dashboard'
    | '/cni/devices'
    | '/cni/facilities'
    | '/cni/features'
    | '/cni/firms'
    | '/cni/licenses'
    | '/cni/packages'
    | '/cni/permissions'
    | '/cni/roles'
    | '/cni/scada'
    | '/cni/ssh-devices'
    | '/cni/tariffs'
    | '/cni/tenants'
    | '/cni/users'
    | '/cni/firms/$id'
    | '/cni/licenses/$id'
    | '/cni/firms/'
    | '/cni/licenses/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/select-panel'
    | '/alarms'
    | '/cni'
    | '/dashboard'
    | '/dealers'
    | '/devices'
    | '/notifications'
    | '/organizations'
    | '/partners'
    | '/push-campaigns'
    | '/remediation'
    | '/sites'
    | '/ssh-devices'
    | '/support'
    | '/users'
    | '/cni/audit'
    | '/cni/dashboard'
    | '/cni/devices'
    | '/cni/facilities'
    | '/cni/features'
    | '/cni/packages'
    | '/cni/permissions'
    | '/cni/roles'
    | '/cni/scada'
    | '/cni/ssh-devices'
    | '/cni/tariffs'
    | '/cni/tenants'
    | '/cni/users'
    | '/cni/firms/$id'
    | '/cni/licenses/$id'
    | '/cni/firms'
    | '/cni/licenses'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/select-panel'
    | '/_authed/alarms'
    | '/_authed/cni'
    | '/_authed/dashboard'
    | '/_authed/dealers'
    | '/_authed/devices'
    | '/_authed/notifications'
    | '/_authed/organizations'
    | '/_authed/partners'
    | '/_authed/push-campaigns'
    | '/_authed/remediation'
    | '/_authed/sites'
    | '/_authed/ssh-devices'
    | '/_authed/support'
    | '/_authed/users'
    | '/_authed/cni/audit'
    | '/_authed/cni/dashboard'
    | '/_authed/cni/devices'
    | '/_authed/cni/facilities'
    | '/_authed/cni/features'
    | '/_authed/cni/firms'
    | '/_authed/cni/licenses'
    | '/_authed/cni/packages'
    | '/_authed/cni/permissions'
    | '/_authed/cni/roles'
    | '/_authed/cni/scada'
    | '/_authed/cni/ssh-devices'
    | '/_authed/cni/tariffs'
    | '/_authed/cni/tenants'
    | '/_authed/cni/users'
    | '/_authed/cni/firms/$id'
    | '/_authed/cni/licenses/$id'
    | '/_authed/cni/firms/'
    | '/_authed/cni/licenses/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SelectPanelRoute: typeof SelectPanelRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/select-panel': {
      id: '/select-panel'
      path: '/select-panel'
      fullPath: '/select-panel'
      preLoaderRoute: typeof SelectPanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support': {
      id: '/_authed/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthedSupportRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ssh-devices': {
      id: '/_authed/ssh-devices'
      path: '/ssh-devices'
      fullPath: '/ssh-devices'
      preLoaderRoute: typeof AuthedSshDevicesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sites': {
      id: '/_authed/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof AuthedSitesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/remediation': {
      id: '/_authed/remediation'
      path: '/remediation'
      fullPath: '/remediation'
      preLoaderRoute: typeof AuthedRemediationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/push-campaigns': {
      id: '/_authed/push-campaigns'
      path: '/push-campaigns'
      fullPath: '/push-campaigns'
      preLoaderRoute: typeof AuthedPushCampaignsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/partners': {
      id: '/_authed/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof AuthedPartnersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/organizations': {
      id: '/_authed/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthedOrganizationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/notifications': {
      id: '/_authed/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthedNotificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/devices': {
      id: '/_authed/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthedDevicesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dealers': {
      id: '/_authed/dealers'
      path: '/dealers'
      fullPath: '/dealers'
      preLoaderRoute: typeof AuthedDealersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cni': {
      id: '/_authed/cni'
      path: '/cni'
      fullPath: '/cni'
      preLoaderRoute: typeof AuthedCniRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/alarms': {
      id: '/_authed/alarms'
      path: '/alarms'
      fullPath: '/alarms'
      preLoaderRoute: typeof AuthedAlarmsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cni/users': {
      id: '/_authed/cni/users'
      path: '/users'
      fullPath: '/cni/users'
      preLoaderRoute: typeof AuthedCniUsersRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/tenants': {
      id: '/_authed/cni/tenants'
      path: '/tenants'
      fullPath: '/cni/tenants'
      preLoaderRoute: typeof AuthedCniTenantsRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/tariffs': {
      id: '/_authed/cni/tariffs'
      path: '/tariffs'
      fullPath: '/cni/tariffs'
      preLoaderRoute: typeof AuthedCniTariffsRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/ssh-devices': {
      id: '/_authed/cni/ssh-devices'
      path: '/ssh-devices'
      fullPath: '/cni/ssh-devices'
      preLoaderRoute: typeof AuthedCniSshDevicesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/scada': {
      id: '/_authed/cni/scada'
      path: '/scada'
      fullPath: '/cni/scada'
      preLoaderRoute: typeof AuthedCniScadaRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/roles': {
      id: '/_authed/cni/roles'
      path: '/roles'
      fullPath: '/cni/roles'
      preLoaderRoute: typeof AuthedCniRolesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/permissions': {
      id: '/_authed/cni/permissions'
      path: '/permissions'
      fullPath: '/cni/permissions'
      preLoaderRoute: typeof AuthedCniPermissionsRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/packages': {
      id: '/_authed/cni/packages'
      path: '/packages'
      fullPath: '/cni/packages'
      preLoaderRoute: typeof AuthedCniPackagesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/licenses': {
      id: '/_authed/cni/licenses'
      path: '/licenses'
      fullPath: '/cni/licenses'
      preLoaderRoute: typeof AuthedCniLicensesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/firms': {
      id: '/_authed/cni/firms'
      path: '/firms'
      fullPath: '/cni/firms'
      preLoaderRoute: typeof AuthedCniFirmsRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/features': {
      id: '/_authed/cni/features'
      path: '/features'
      fullPath: '/cni/features'
      preLoaderRoute: typeof AuthedCniFeaturesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/facilities': {
      id: '/_authed/cni/facilities'
      path: '/facilities'
      fullPath: '/cni/facilities'
      preLoaderRoute: typeof AuthedCniFacilitiesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/devices': {
      id: '/_authed/cni/devices'
      path: '/devices'
      fullPath: '/cni/devices'
      preLoaderRoute: typeof AuthedCniDevicesRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/dashboard': {
      id: '/_authed/cni/dashboard'
      path: '/dashboard'
      fullPath: '/cni/dashboard'
      preLoaderRoute: typeof AuthedCniDashboardRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/audit': {
      id: '/_authed/cni/audit'
      path: '/audit'
      fullPath: '/cni/audit'
      preLoaderRoute: typeof AuthedCniAuditRouteImport
      parentRoute: typeof AuthedCniRoute
    }
    '/_authed/cni/licenses/': {
      id: '/_authed/cni/licenses/'
      path: '/'
      fullPath: '/cni/licenses/'
      preLoaderRoute: typeof AuthedCniLicensesIndexRouteImport
      parentRoute: typeof AuthedCniLicensesRoute
    }
    '/_authed/cni/firms/': {
      id: '/_authed/cni/firms/'
      path: '/'
      fullPath: '/cni/firms/'
      preLoaderRoute: typeof AuthedCniFirmsIndexRouteImport
      parentRoute: typeof AuthedCniFirmsRoute
    }
    '/_authed/cni/licenses/$id': {
      id: '/_authed/cni/licenses/$id'
      path: '/$id'
      fullPath: '/cni/licenses/$id'
      preLoaderRoute: typeof AuthedCniLicensesIdRouteImport
      parentRoute: typeof AuthedCniLicensesRoute
    }
    '/_authed/cni/firms/$id': {
      id: '/_authed/cni/firms/$id'
      path: '/$id'
      fullPath: '/cni/firms/$id'
      preLoaderRoute: typeof AuthedCniFirmsIdRouteImport
      parentRoute: typeof AuthedCniFirmsRoute
    }
  }
}

interface AuthedCniFirmsRouteChildren {
  AuthedCniFirmsIdRoute: typeof AuthedCniFirmsIdRoute
  AuthedCniFirmsIndexRoute: typeof AuthedCniFirmsIndexRoute
}

const AuthedCniFirmsRouteChildren: AuthedCniFirmsRouteChildren = {
  AuthedCniFirmsIdRoute: AuthedCniFirmsIdRoute,
  AuthedCniFirmsIndexRoute: AuthedCniFirmsIndexRoute,
}

const AuthedCniFirmsRouteWithChildren = AuthedCniFirmsRoute._addFileChildren(
  AuthedCniFirmsRouteChildren,
)

interface AuthedCniLicensesRouteChildren {
  AuthedCniLicensesIdRoute: typeof AuthedCniLicensesIdRoute
  AuthedCniLicensesIndexRoute: typeof AuthedCniLicensesIndexRoute
}

const AuthedCniLicensesRouteChildren: AuthedCniLicensesRouteChildren = {
  AuthedCniLicensesIdRoute: AuthedCniLicensesIdRoute,
  AuthedCniLicensesIndexRoute: AuthedCniLicensesIndexRoute,
}

const AuthedCniLicensesRouteWithChildren =
  AuthedCniLicensesRoute._addFileChildren(AuthedCniLicensesRouteChildren)

interface AuthedCniRouteChildren {
  AuthedCniAuditRoute: typeof AuthedCniAuditRoute
  AuthedCniDashboardRoute: typeof AuthedCniDashboardRoute
  AuthedCniDevicesRoute: typeof AuthedCniDevicesRoute
  AuthedCniFacilitiesRoute: typeof AuthedCniFacilitiesRoute
  AuthedCniFeaturesRoute: typeof AuthedCniFeaturesRoute
  AuthedCniFirmsRoute: typeof AuthedCniFirmsRouteWithChildren
  AuthedCniLicensesRoute: typeof AuthedCniLicensesRouteWithChildren
  AuthedCniPackagesRoute: typeof AuthedCniPackagesRoute
  AuthedCniPermissionsRoute: typeof AuthedCniPermissionsRoute
  AuthedCniRolesRoute: typeof AuthedCniRolesRoute
  AuthedCniScadaRoute: typeof AuthedCniScadaRoute
  AuthedCniSshDevicesRoute: typeof AuthedCniSshDevicesRoute
  AuthedCniTariffsRoute: typeof AuthedCniTariffsRoute
  AuthedCniTenantsRoute: typeof AuthedCniTenantsRoute
  AuthedCniUsersRoute: typeof AuthedCniUsersRoute
}

const AuthedCniRouteChildren: AuthedCniRouteChildren = {
  AuthedCniAuditRoute: AuthedCniAuditRoute,
  AuthedCniDashboardRoute: AuthedCniDashboardRoute,
  AuthedCniDevicesRoute: AuthedCniDevicesRoute,
  AuthedCniFacilitiesRoute: AuthedCniFacilitiesRoute,
  AuthedCniFeaturesRoute: AuthedCniFeaturesRoute,
  AuthedCniFirmsRoute: AuthedCniFirmsRouteWithChildren,
  AuthedCniLicensesRoute: AuthedCniLicensesRouteWithChildren,
  AuthedCniPackagesRoute: AuthedCniPackagesRoute,
  AuthedCniPermissionsRoute: AuthedCniPermissionsRoute,
  AuthedCniRolesRoute: AuthedCniRolesRoute,
  AuthedCniScadaRoute: AuthedCniScadaRoute,
  AuthedCniSshDevicesRoute: AuthedCniSshDevicesRoute,
  AuthedCniTariffsRoute: AuthedCniTariffsRoute,
  AuthedCniTenantsRoute: AuthedCniTenantsRoute,
  AuthedCniUsersRoute: AuthedCniUsersRoute,
}

const AuthedCniRouteWithChildren = AuthedCniRoute._addFileChildren(
  AuthedCniRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAlarmsRoute: typeof AuthedAlarmsRoute
  AuthedCniRoute: typeof AuthedCniRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDealersRoute: typeof AuthedDealersRoute
  AuthedDevicesRoute: typeof AuthedDevicesRoute
  AuthedNotificationsRoute: typeof AuthedNotificationsRoute
  AuthedOrganizationsRoute: typeof AuthedOrganizationsRoute
  AuthedPartnersRoute: typeof AuthedPartnersRoute
  AuthedPushCampaignsRoute: typeof AuthedPushCampaignsRoute
  AuthedRemediationRoute: typeof AuthedRemediationRoute
  AuthedSitesRoute: typeof AuthedSitesRoute
  AuthedSshDevicesRoute: typeof AuthedSshDevicesRoute
  AuthedSupportRoute: typeof AuthedSupportRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAlarmsRoute: AuthedAlarmsRoute,
  AuthedCniRoute: AuthedCniRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDealersRoute: AuthedDealersRoute,
  AuthedDevicesRoute: AuthedDevicesRoute,
  AuthedNotificationsRoute: AuthedNotificationsRoute,
  AuthedOrganizationsRoute: AuthedOrganizationsRoute,
  AuthedPartnersRoute: AuthedPartnersRoute,
  AuthedPushCampaignsRoute: AuthedPushCampaignsRoute,
  AuthedRemediationRoute: AuthedRemediationRoute,
  AuthedSitesRoute: AuthedSitesRoute,
  AuthedSshDevicesRoute: AuthedSshDevicesRoute,
  AuthedSupportRoute: AuthedSupportRoute,
  AuthedUsersRoute: AuthedUsersRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SelectPanelRoute: SelectPanelRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
